import { useAuth0 } from "@auth0/auth0-react";
import React, { createContext } from "react";

const TokenContext = createContext<{ token: null | string }>({
  token: null,
});

const TokenContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [token, setToken] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((newToken) => {
        setToken(newToken);
      });
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return <TokenContext.Provider value={{ token }}>{children}</TokenContext.Provider>;
};

export { TokenContext, TokenContextProvider };
